import { API } from '../../constants';

export function getApiBaseUrl() {
  // Return empty string to use relative URLs
  return '';
}

export const API_VERSION = API.VERSION;

export * from './common';
export * from './plugins';
export * from './credentials';
export * from './setupWizard';
export * from './pages';
export * from './spaces';
export * from './launchers';
export * from './machines';
export * from './tasks';
export * from './redirects';
export * from './blog';
export * from './contact';
export * from './permissions';
export * from './packages';